import type { FC } from 'react';

/** V1's InternalDynamicDataIcon (data from this form), as used on placeholder chips. */
export const DynamicDataIcon: FC<{ className?: string }> = ({ className }) => (
  <svg className={`inline ${className ?? ''}`} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <circle cx="4.88881" cy="3.3329" r="1.55556" fill="currentColor" />
    <circle cx="11.111" cy="12.6649" r="1.55556" fill="currentColor" />
    <path d="M4.88892 4.10938V10.3316C4.88892 11.6203 5.93359 12.6649 7.22225 12.6649H10.3334" stroke="currentColor" strokeWidth="0.777778" />
  </svg>
);

/** V1's ExternalDynamicDataIcon (data from a linked form). */
export const ExternalDynamicDataIcon: FC<{ className?: string }> = ({ className }) => (
  <svg className={`inline ${className ?? ''}`} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <ellipse cx="2.66667" cy="2.5" rx="2.66667" ry="2" fill="currentColor" />
    <ellipse cx="13.3334" cy="9.5" rx="2.66667" ry="2" fill="currentColor" />
    <ellipse cx="13.3334" cy="14.5" rx="2.66667" ry="2" fill="currentColor" />
    <path d="M2.66669 3.5V7C2.66669 8.65685 4.00983 10 5.66669 10H12" stroke="currentColor" />
    <path d="M2.66669 3.5V11.5C2.66669 13.1569 4.00983 14.5 5.66669 14.5H12" stroke="currentColor" />
  </svg>
);
